import axios from 'axios'
export default {
    namespaced: true,
    state:{
        tips:'',
        refund:'',
        status:'none',
    },
    getters:{

    },
    actions:{
        load({commit, state}) {
            return new Promise((resolve, reject) => {
               if(state.status != 'none')
                   return;

                axios.get('pages/course-terms')
                    .then(({data}) => {
                        commit('loaded', data);
                        return resolve();
                    })
                    .catch(() => reject())
            });
        }
    },
    mutations:{
        loaded(state,data){
            state.tips = data.tips;
            state.refund = data.refund;
            state.status = 'loaded';
        },
    }
}